// src/pages/TenantManagement/validation.ts
// Yup validation schemas for Tenant Management

import * as Yup from 'yup';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('tenant_management');

/**
 * Shared validation schema for Create and Edit
 * @param isEdit - If true, code validation is skipped (code is immutable)
 */
export const createTenantSchema = (isEdit: boolean = false) =>
  Yup.object().shape({
    code: isEdit
      ? Yup.string().nullable()
      : Yup.string()
          .required(st('ma_don_vi_bat_buoc_error'))
          .matches(
            /^[A-Z0-9_]+$/,
            st('ma_chi_duoc_chua_chu_hoa_error')
          )
          .min(2, st('ma_phai_co_it_nhat_2_error'))
          .max(20, st('ma_khong_duoc_qua_20_ky_error')),
    name: Yup.string()
      .required(st('ten_don_vi_bat_buoc_error'))
      .min(3, st('ten_phai_co_it_nhat_3_error'))
      .max(200, st('ten_khong_duoc_qua_200_ky_error')),
    type: Yup.string()
      .required(st('loai_don_vi_bat_buoc_error')),
    description: Yup.string()
      .max(500, st('mo_ta_khong_duoc_qua_500_error')),
    address: Yup.string()
      .max(255, st('dia_chi_khong_duoc_qua_255_error'))
      .when('type', {
        is: '2',
        then: (schema) => schema.required(st('dia_chi_bat_buoc_doi_voi_error')),
      }),
    phone: Yup.string()
      .matches(/^[0-9]{10,11}$/, st('so_dien_thoai_phai_co_10_error')),
    email: Yup.string()
      .email(st('email_khong_hop_le_error'))
      .max(100, st('email_khong_duoc_qua_100_ky_error')),
    parentId: Yup.number()
      .nullable()
      .transform((value, originalValue) => 
        originalValue === '' ? null : value
      ),
  });